import StNativeUrlConnector from '@stilingue/st-native-url-connector';

export default function StURLController(urlConnector) {
  return {
    getParamsFromURL() {
      return urlConnector.getQueryParams();
    },
    getParamsByName(paramName, defaultValue = '') {
      return urlConnector.getQueryParamByName(paramName) || defaultValue;
    },
    setParamInUrl(paramName, paramValue) {
      urlConnector.setQuery({ [paramName]: paramValue });
      return this;
    },
    removeParamInUrl(paramName) {
      return urlConnector.removeQueryParam(paramName);
    }
  };
}

export const URLControllerFactory = {
  native(Connector = StNativeUrlConnector) {
    const nativeConnector = Connector(window);
    return StURLController(nativeConnector);
  }
};

